import { AuthContext } from '@core/shared';
import { ClientType, LiveStatus } from '@core/types';
import { ErrorMessagePage, Loader, TestWebinarBadge } from '@core/ui';
import { AccountWizardPage } from '@online-webinar/account';
import { useParams } from '@online-webinar/router';
import { joinWebinar, leaveWebinar, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { useContext, useEffect } from 'react';
import { SpeakerWaitingRoom } from '../../organism';

export const SpeakerPage = () => {
    const { webinarId, linkCode } = useParams({ strict: false });
    const dispatch = useAppDispatch();
    const isAuthenticated = useContext(AuthContext).isAuthenticated;

    // Hide the app chrome for the whole /s/ lifetime. Kept separate from the auth-gated
    // join effect so cleanup ALWAYS runs on unmount — external speakers reach this route
    // unauthenticated (no authGuard), so unmounting-while-logged-out is the common case.
    useEffect(() => {
        document.body.classList.add('no-menu');
        return () => document.body.classList.remove('no-menu');
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        dispatch(joinWebinar({ webinarId: webinarId!, authenticationCode: linkCode!, clientType: ClientType.speaker }));
        return () => {
            dispatch(leaveWebinar());
        };
    }, [isAuthenticated]);

    const isInitialized = useAppSelector((state) => state.liveWebinar.isInitialized);
    const dataConnection = useAppSelector((state) => state.liveWebinar.dataConnection);
    const isTest = useAppSelector((state) => state.liveWebinar.webinarData.isTest);

    if (!webinarId) {
        return <ErrorMessagePage statusCode={404} />;
    }

    if (!isAuthenticated) {
        return <AccountWizardPage />;
    }

    if (dataConnection.status === LiveStatus.Error) {
        const error = dataConnection.error ?? { statusCode: 500, success: false };
        return <ErrorMessagePage apiError={error} />;
    }

    if (!isInitialized) {
        return <Loader classNames="m-auto" />;
    }

    return (
        <>
            {isTest && <TestWebinarBadge classNames="fixed top-2 left-2 z-50" />}
            <SpeakerWaitingRoom />
        </>
    );
};
